import i18n, { InitOptions, Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import { ALL_LANGUAGES, LANGUAGE_FALLBACKS } from "./constants";

export const config = <T = object>(
  lng: string,
  resources: Resource,
  options?: Partial<InitOptions<T>>,
): InitOptions<T> => ({
  lng,
  resources,
  defaultNS: "website2.website",
  ns: "website2.website",
  load: "all",
  supportedLngs: ["en", ...ALL_LANGUAGES],
  react: {
    useSuspense: false,
  },
  fallbackLng: LANGUAGE_FALLBACKS, // Fallback language if detection fails
  debug: false,
  interpolation: {
    prefix: "__",
    suffix: "__",
    /**
     * escape values to prevent XSS injection because translate/translateWithFallback
     * are parsing the translated string into DOM elements to be able to render and display HTML
     * in translations
     *
     * @see TranslationContext in @src/components/translation/TranslationContext.tsx
     * and its use of html-react-parser
     */
    escapeValue: true,
  },
  detection: {
    order: ["path", "htmlTag", "cookie", "navigator"],
    lookupFromPathIndex: 0,
  },
  ...options,
});

export const getBaseI18n = async () => {
  await i18n.use(initReactI18next);
  return i18n;
};
